module.exports = __webpack_public_path__ + "img/kona-25.4bbf4fc3.png";